export const SAVE_PRODUCTS = "SAVE-PRODUCTS";
export const LOADING_PRODUCTS = "LOADING-PRODUCTS";
export const IS_MODAL_ADD_TO_CART_OPEN = 'IS_MODAL_ADD_TO_CART_OPEN';
export const IS_MODAL_ADD_TO_CART_CLOSE = 'IS_MODAL_ADD_TO_CART_CLOSE';
export const IS_MODAL_REMOVE_FROM_CART = 'IS_MODAL_REMOVE_FROM_CART';
export const IS_MODAL_REMOVE_FROM_CART_CLOSE = 'IS_MODAL_REMOVE_FROM_CART_CLOSE';
export const TO_BUY = 'TO_BUY';
export const CLOSE_TO_BUY_MODAL = 'CLOSE_TO_BUY_MODAL';
export const BUYER_INFO = 'BUYER_INFO';
